import {
  PRICE_REQUEST_MESSAGE_START,
  PRICE_REQUEST_MESSAGE_SUCCESS,
  PRICE_REQUEST_MESSAGE_FAILURE
} from '../actionTypes';
// eslint-disable-next-line import/extensions
import * as api from '../api.js';

export const priceRequestMessage = formData => async dispatch => {
  dispatch({ type: PRICE_REQUEST_MESSAGE_START });

  api
    .priceRequestMessage(formData)
    .then(data => {
      dispatch({
        type: PRICE_REQUEST_MESSAGE_SUCCESS,
        payload: data
      });
    })
    .catch(err => {
      dispatch({
        type: PRICE_REQUEST_MESSAGE_FAILURE,
        payload: err,
        error: true
      });
    });
};
